import Button from '../../Button/Button';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';

type YearSelectorHeaderProps = {
    startYear: number;
    endYear?: number | null;
    onYearRangeChange: (prevNext: boolean) => void;
};
export default function YearSelectorHeader({
    startYear,
    endYear,
    onYearRangeChange,
}: YearSelectorHeaderProps) {
    const handlePreviousYear = () => {
        onYearRangeChange(false);
    };
    const handleNextYear = () => {
        onYearRangeChange(true);
    };

    const displayYears = endYear
        ? `${startYear} - ${endYear}`
        : startYear.toString();
    return (
        <div className="alli-flex alli-items-center alli-text-gray-900">
            <Button
                onClick={handlePreviousYear}
                variant="text-secondary"
                type="button"
                className="alli-text-primary alli--m-1.5 alli-flex alli-flex-none alli-items-center alli-justify-center alli-p-1.5 hover:alli-text-gray-500">
                <span className="alli-sr-only">Previous Years</span>
                <ChevronLeftIcon className="alli-size-5" aria-hidden="true" />
            </Button>
            <div className="alli-flex-auto alli-text-center alli-text-sm alli-font-semibold">
                {displayYears}
            </div>
            <Button
                onClick={handleNextYear}
                variant="text-secondary"
                type="button"
                className="alli-text-primary alli--m-1.5 alli-flex alli-flex-none alli-items-center alli-justify-center alli-p-1.5 hover:alli-text-gray-500">
                <span className="alli-sr-only">Next Years</span>
                <ChevronRightIcon className="alli-size-5" aria-hidden="true" />
            </Button>
        </div>
    );
}
